import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const TIPO_OPTIONS = [
  { value: 'O', label: 'Original' },
  { value: 'C', label: 'Cópia' },
];

const TIPO_PESSOA_OPTIONS = [
  { value: 'F', label: 'Física' },
  { value: 'J', label: 'Jurídica' },
  { value: 'A', label: 'Ambos' },
];

const formatTipoDoc = (valor) => {
  if (valor === 'ORIGINAL' || valor === 'O') return 'Original';
  if (valor === 'CÓPIA' || valor === 'C') return 'Cópia';
  return valor || '-';
};

const formatTipoPessoa = (valor) => {
  if (valor === 'F') return 'Física';
  if (valor === 'J') return 'Jurídica';
  if (valor === 'A') return 'Ambos';
  return valor || '-';
};

const GridDocumentos = ({ codigoFamilia, documentos, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [docOptions, setDocOptions] = useState([]);
  const [docSelected, setDocSelected] = useState(null);
  const [qtd, setQtd] = useState('');
  const [tipo, setTipo] = useState('');
  const [tipoPessoa, setTipoPessoa] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!showForm) return;
    api.listarDocVendaConfig()
      .then((res) => {
        const dados = res && res.data ? res.data : (res || []);
        const opts = (Array.isArray(dados) ? dados : []).map((d) => ({
          value: d.key,
          label: d.key + ' - ' + d.value,
        }));
        setDocOptions(opts);
      })
      .catch(() => { toast.error('Erro ao carregar documentos'); });
  }, [showForm]);

  const handleAbrirForm = () => {
    setDocSelected(null);
    setQtd('');
    setTipo('');
    setTipoPessoa('');
    setShowForm(true);
  };

  const handleIncluir = async () => {
    if (docSelected == null) {
      toast.warn('Selecione um documento.');
      return;
    }
    if (!tipoPessoa) {
      toast.warn('Selecione o tipo de pessoa.');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirDocumentoConfig({
        codigo_familia: codigoFamilia,
        codigo_doc: docSelected.value,
        tipo: tipo || null,
        qtd: qtd !== '' ? Number(qtd) : null,
        tipo_pessoa: tipoPessoa,
      });
      toast.success('Documento incluído com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir documento';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir o documento "' + item.doc_venda + '"?')) return;
    try {
      await api.excluirDocumentoConfig({
        codigo_familia: codigoFamilia,
        codigo_doc: item.codigo_doc,
        tipo_pessoa: item.tipo_pessoa,
      });
      toast.success('Documento excluído!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir documento';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Documentos</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Documento *</Form.Label>
                  <Select
                    options={docOptions}
                    value={docSelected}
                    onChange={setDocSelected}
                    placeholder="Selecione documento..."
                    isClearable
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Qtd</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    min={1}
                    value={qtd}
                    onChange={(e) => setQtd(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Tipo</Form.Label>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {TIPO_OPTIONS.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Tipo Pessoa *</Form.Label>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={tipoPessoa}
                    onChange={(e) => setTipoPessoa(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {TIPO_PESSOA_OPTIONS.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Documento</th>
              <th style={{ width: 60 }}>Qtd</th>
              <th style={{ width: 100 }}>Tipo</th>
              <th style={{ width: 100 }}>Pessoa</th>
              <th style={{ width: 60 }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {documentos.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  Nenhum documento cadastrado
                </td>
              </tr>
            )}
            {documentos.map((item) => (
              <tr key={item.codigo_doc + '-' + item.tipo_pessoa}>
                <td>{item.doc_venda}</td>
                <td>{item.qtd != null ? item.qtd : '-'}</td>
                <td>{formatTipoDoc(item.tipo_doc)}</td>
                <td>{formatTipoPessoa(item.tipo_pessoa)}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridDocumentos;
